<template>
  <div
    class="text-center"
  >
    <h1
      v-t="'JOIN_INVITE_FAILURE'"
      class="title md-title"
    />
    <p
      class="subtitle"
    >
      {{ inviteStatus.errorMessage }}
    </p>
    <a
      v-t="'BACK_LOGIN_LINK'"
      href="#"
      class="button button--transparent-grad pulse m-t-20"
      @click="goToLogin"
    />
  </div>
</template>

<script>
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import messages from '../locales';

export default {
  props: {
    inviteStatus: {
      type: Object,
      default() {
        return {};
      },
    }
  },
  methods: {
    goToLogin() {
      $ngStateService.go('login');
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>

</style>